module.exports = __webpack_public_path__ + "images/xl_shanxi.png?e199f33387d16e61a5bdc5fea979c351";


//////////////////
// WEBPACK FOOTER
// ./src/images/xl_shanxi.png
// module id = 249
// module chunks = 1